import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { ProductViewDetailsComponent } from '../../../product-view-details/product-view-details.component';
import { GridProductStyle, ProductViewTemplateModel } from '../../models/product-view-template.model';

import { ProductPublicModels } from '@features/products/product';
import { GridType } from '@shared/models/grid-type.model';
import { ProductMapPrices } from '@shared/prices/models/product-prices.model';
import { CategoryConfiguration } from '@shared/product/models';

@Component({
    selector: 'product-view-footer',
    templateUrl: './product-view-footer.component.html',
    imports: [
        ProductViewDetailsComponent,
    ],
    // eslint-disable-next-line @angular-eslint/no-host-metadata-property
    host: { class: 'product-view-footer' },
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class ProductViewFooterComponent {
    public product = input.required<ProductPublicModels.PublicProduct>();

    public productStyle = input<GridProductStyle>(); // se debería agregar al categoryConfig

    public config = input<ProductViewTemplateModel>();

    public gridType = input<GridType>();

    public categoryConfig = input<CategoryConfiguration>();

    public prices = input<ProductMapPrices>();

    public readonly navigate = output<Event>();

    public navigateToProduct(event: Event): void {
        this.navigate.emit(event);
    }
}
